import React from "react";

import { BackTop, Layout } from "antd";

import { AdminRoutesList, UserRoutesList } from "../../routes";
import { Header } from "../header";
import { Sidebar } from "../sidebar";

export const AdminLayout: React.FC = () => {
  return (
    <>
      <Header />
      <Layout>
        <BackTop />
        <AdminRoutesList />
      </Layout>
    </>
  );
};

export const UserLayout: React.FC = () => {
  return (
    <>
      <Header />
      <Layout>
        <Sidebar />
        <Layout.Content style={{ marginTop: "30px" }}>
          <BackTop />
          <UserRoutesList />
        </Layout.Content>
      </Layout>
    </>
  );
};
